<script setup lang="ts">
defineProps<{
  label: string;
  hint?: string;
}>();
</script>

<template>
  <label class="nx-settings-field">
    <span class="nx-settings-field-label">{{ label }}</span>
    <slot />
    <span v-if="hint" class="nx-settings-field-hint">{{ hint }}</span>
  </label>
</template>

<style scoped>
.nx-settings-field {
  display: flex;
  flex-direction: column;
  gap: var(--nxt-space-2xs);
  min-width: 0;
}

.nx-settings-field-label {
  color: var(--nxt-fg-muted);
  font-size: var(--nxt-font-size-xs);
  font-weight: var(--nxt-font-weight-semibold);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.nx-settings-field-hint {
  color: var(--nxt-fg-subtle);
  font-size: var(--nxt-font-size-xs);
  line-height: var(--nxt-line-height-normal);
}

.nx-settings-field :deep(input[type='number']),
.nx-settings-field :deep(input[type='time']),
.nx-settings-field :deep(input[type='datetime-local']),
.nx-settings-field :deep(input[type='search']) {
  min-height: var(--nxt-control-size-md);
  min-width: 0;
  padding: 0 var(--nxt-space-xs);
  color: var(--nxt-fg);
  background: var(--nxd-surface-bg);
  border: var(--nxt-hairline) solid var(--nxt-border);
  border-radius: var(--nxt-radius-sm);
  font: inherit;
  outline: 0;
}

.nx-settings-field :deep(input:focus-visible) {
  border-color: var(--nxt-brand-bg);
  box-shadow: 0 0 0 calc(var(--nxt-hairline) * 2) var(--nxt-brand-subtle-bg);
}

.nx-settings-field :deep(input:disabled) {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
